import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { User } from "src/classes/Automation/UserApp";
import { ParameterSMS } from "src/classes/Automation/Templates";
import { HttpService1 } from "src/app/services/Automation/http/http.service_smsAppointment";
import { TokenValid } from "src/classes/Automation/TokenValid";
import { SetTemplateValid } from "src/classes/Automation/TemplatesSave";
import { BodiesForCase } from "src/classes/Automation/BodiesForCase";
import { Tag } from "src/classes/Automation/Tag";
import { NGXLogger } from "ngx-logger";
import { activeTemplates } from "src/environments/environment";
import { ChildadminpanelComponent } from "../childadminpanel/childadminpanel.component";
import { ChildeditorComponent } from "../childeditor/childeditor.component";
import { DynamicDialogService } from "src/app/services/Customer/dynamic-dialog/dynamic-dialog.service";
// import { HMessage } from "src/classes/Automation/HMessage";
// import { HRMessage } from "src/classes/Automation/HRMessage";

@Component({
    selector: "app-templatesms",
    templateUrl: "./templatesms.component.html",
    styleUrls: ["./templatesms.component.css"],
    providers: [HttpService1],
})
export class TemplatesmsComponent implements OnInit, OnDestroy {
    user: User = new User();
    receivedparameters: ParameterSMS = new ParameterSMS();
    receivedsettemplatevalid: SetTemplateValid = new SetTemplateValid();
    tokenvalid: TokenValid = new TokenValid();
    receivetokenvalid: TokenValid = new TokenValid();
    // hmessage: HMessage = new HMessage();
    // hrmessage: HRMessage = new HRMessage();

    isLoaderVisible: boolean = true;

    saveData: boolean = false;
    componentHasChanged: boolean = false;

    bodiescase: BodiesForCase = new BodiesForCase();

    layouts: Tag[];

    isFirstInputValid: boolean = true;
    isEditingFirstInput: boolean = false;
    isSecondInputValid: boolean = true;
    isEditingSecondInput: boolean = false;
    previousInputValue: string;

    methodData: { id: number, name: string }[] = [
        {
            id: 1,
            name: "אוטומטי",
        },
        {
            id: 2,
            name: "שאל אותי כל פעם",
        },
    ];

    timeData: { id: number, name: string }[] = [
        {
            id: 1,
            name: "היום",
        },
        {
            id: 2,
            name: "השבוע",
        },
        {
            id: 3,
            name: "החודש",
        },
    ];

    meetingMethodData: { id: number, name: string }[] = [
        {
            id: 1,
            name: "אטומטי",
        },
        {
            id: 2,
            name: "לאשול אותי",
        },
    ];

    isDialogVisible: boolean = false;
    isPreviewDialogVisible: boolean = false;
    dialogTitle: string = "";
    dialogMessage: string = "";

    @ViewChild("firstInput", { static: false }) firstInput: ElementRef<HTMLInputElement>;
    @ViewChild("secondInput", { static: false }) secondInput: ElementRef<HTMLInputElement>;

    constructor(
        private router: Router,
        private httpService1: HttpService1,
        private logger: NGXLogger,
        private dynamicDialogService: DynamicDialogService,
    ) { }

    ngOnInit(): void {
        this.meetingMethodData = this.meetingMethodData.filter(item => item.id !== 2); // temporary

        this.user.useremail = sessionStorage.getItem("email");
        this.IsTokenValid();

        this.getDataTemplates();

        this.httpService1.getDataBodiesForCase(this.user)
            .subscribe((res: BodiesForCase) => {
                this.bodiescase = res;

                if (Object.keys(this.receivedparameters).length) {
                    this.casebody();
                }
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });

        this.httpService1.getDataTags(this.user)
            .subscribe((res: Tag[]) => {
                this.layouts = res;
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });
    }

    ngOnDestroy(): void {
        this.dynamicDialogService.closeDialog();
    }

    IsTokenValid(): void {
        this.receivetokenvalid.answer = false;
        this.tokenvalid.token = sessionStorage.getItem("tokenAutomation");
console.log("Token from sessionStorage: " + this.tokenvalid.token);
        if (!this.tokenvalid.token) {
            this.httpService1.postDataLogin(this.user).subscribe((res: User) => {
                sessionStorage.setItem("tokenAutomation", res.token);
                this.tokenvalid.token = sessionStorage.getItem("tokenAutomation");
console.log("Token after: " + this.tokenvalid.token);

                if (!res.token) {
                    console.log("Not valid email:" + this.user.useremail);
                    this.logger.error("Not valid email: " + sessionStorage.getItem("email"));
                    this.router.navigate([""]);
                    return;
                }

                this.httpService1.postIsTokenValid(this.tokenvalid)
                    .subscribe((res: TokenValid) => {
                        this.receivetokenvalid = res;
                        this.receivetokenvalid.answer = res.answer;
                        if (!this.receivetokenvalid.answer) {
                            this.router.navigate([""]);
                        }
                    }, error => {
                        console.log(error);
                        this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
                    });
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });
        }
        else {
            this.httpService1.postIsTokenValid(this.tokenvalid)
                .subscribe((res: TokenValid) => {
                    this.receivetokenvalid = res;
                    this.receivetokenvalid.answer = res.answer;
                    if (!this.receivetokenvalid.answer) {
                        this.router.navigate([""]);
                    }
                }, error => {
                    console.log(error);
                    this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
                });
        }
    }

    handleChange(templateName: string, templateId: number): void {
        this.receivedparameters[templateName] = !this.receivedparameters[templateName];

        if (templateName == "automaticClosingCash" && !this.receivedparameters.automaticClosingCash) {
            this.receivedparameters.sendReportCash = false;
        }

        if (templateName == "sendReportCash" || templateName == "automaticClosingCash") {
            if (this.isEditingFirstInput) {
                this.cancelInput(1);
            }
            if (this.isEditingSecondInput) {
                this.cancelInput(2);
            }
        }

        //---for async call service
        /*           this.hmessage.Message=this.txtmessage;
                     this.hmessage.ConStr=this.receivedparameters.connection_string;
                     this.hmessage.KeyTitle=this.titlekeyVisit;
                     this.httpService1.postMessageHelp(this.hmessage).then((res:HRMessage) => {
                     this.hrmessage = res; this.hrmessage.responceMessage=res.responceMessage;
                     console.log(this.hrmessage.responceMessage);
                     console.log(this.hrmessage.statusMessage);
                     } ,error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            } );  */
        //---for async call service

        if (!activeTemplates[templateId - 1]) {
            setTimeout(() => {
                this.receivedparameters[templateName] = false;

                if (document.getElementsByClassName("modal").length == 0) {
                    this.dialogTitle = "הודעה למשתמש";
                    this.dialogMessage = "אופציה זו עדיין לא פעילה, אך בקרוב תוכלו להשתמש גם בה."
                    this.isDialogVisible = true;
                }
            }, 500);
        }
    }

    timeValueDecrement(model: string, limit: number, step?: number): void {
        if (this.receivedparameters[model] > limit) {
            this.receivedparameters[model] -= (step || 1);
        }

        if (model == "daysbefore") {
            this.casebody();
        }
    }

    timeValueIncrement(model: string, limit: number, step?: number): void {
        if (this.receivedparameters[model] < limit) {
            this.receivedparameters[model] += (step || 1);
        }

        if (model == "daysbefore") {
            this.casebody();
        }
    }

    onRangeFocus(target: HTMLInputElement): void {
        target.select();
    }

    onRangeChange(model: string, eventTarget: HTMLInputElement, minValue?: number, maxValue?: number): void {
        this.receivedparameters[model] = +this.receivedparameters[model].replace(/[^0-9*#]/g, "");

        if (minValue && this.receivedparameters[model] < minValue) {
            this.receivedparameters[model] = minValue;
        }
        if (maxValue && this.receivedparameters[model] > maxValue) {
            this.receivedparameters[model] = maxValue;
        }

        eventTarget.value = this.receivedparameters[model];
    }

    getSMSCount(model: string): number {
        if (this.receivedparameters[model]) {
            return Math.ceil(this.receivedparameters[model].length / 200);
        }
        return 0;
    }

    onBirthdayMethodChange(): void {
        if (this.receivedparameters.birthdayMethod == 1) {
            this.timeData.push({ id: 3, name: 'החודש' });
        }
        else if (this.receivedparameters.birthdayMethod == 2) {
            if (this.receivedparameters.birthdayPeriodic == 3) {
                this.receivedparameters.birthdayPeriodic = 1;
                this.receivedparameters.bodyBirthday = this.bodiescase.bodyBirthday_1;
            }
            this.timeData = this.timeData.filter(item => item.id != 3);

            this.dialogTitle = "הודעה למשתמש";
            this.dialogMessage = "במצב של <שאל אותי כל פעם> תקפוץ התראת ימי-הולדת בתוכנה עצמה, אך שימו לב שבמקרה זה הנוסח של ההודעות יהיה הנוסח ששמור בתוכנה (דרך התאמה -> עדכון תבניות סמס), ולא הנוסח האוטומטי שמופיע פה למטה"
            this.isDialogVisible = true;
        }
    }

    onBirthdayPeriodicChange(): void {
        if (this.receivedparameters.birthdayPeriodic == 1) {
            this.receivedparameters.bodyBirthday = this.bodiescase.bodyBirthday_1;
        }
        else if (this.receivedparameters.birthdayPeriodic == 2) {
            this.receivedparameters.bodyBirthday = this.bodiescase.bodyBirthday_2;
        }
        else if (this.receivedparameters.birthdayPeriodic == 3) {
            this.receivedparameters.bodyBirthday = this.bodiescase.bodyBirthday_3;
        }
    }

    openEditor(textareaName: string, templateId: number): void {
        this.dynamicDialogService.openDialog(ChildeditorComponent, {
            data: {
                message: this.receivedparameters[textareaName],
                textareaId: templateId,
                layouts: this.layouts
            },
            styleClass: "modal modal_purpose_sms-editor",
            closeOnEscape: false,
            showHeader: false
        }).onClose.subscribe((message: string) => {
            if (message != undefined) {
                this.receivedparameters[textareaName] = message;

                if (textareaName === "bodyvizit") {
                    if (message.split(`[${this.layouts.find(x => x.name == "Link").hebrew_name}]`).length == 1) {
                        this.receivedparameters.isAddLink = false;
                    }
                    else {
                        this.receivedparameters.isAddLink = true;
                    }
                }

                if (this.receivedparameters.daysbefore > 1 && this.receivedparameters.isAddLink == false) {
                    this.bodiescase.bodyvizit_2 = message;
                }
                else if (this.receivedparameters.daysbefore == 1 && this.receivedparameters.isAddLink == false) {
                    this.bodiescase.bodyvizit_1 = message;
                }

                if (this.receivedparameters.daysbefore > 1 && this.receivedparameters.isAddLink == true) {
                    this.bodiescase.bodyvizit_2_i = message;
                }
                else if (this.receivedparameters.daysbefore == 1 && this.receivedparameters.isAddLink == true) {
                    this.bodiescase.bodyvizit_1_i = message;
                }
            }
        });
    }

    previewText(textareaName: string): void {
        let message = this.receivedparameters[textareaName];

        this.layouts.forEach((layout: any) => {
            if (message.indexOf(layout.hebrew_name)) {
                if (layout.preview_txt && layout.preview_txt.includes("http")) {
                    layout.preview_txt = layout.preview_txt.split("/").join("/​"); // Do not remove special symbol
                }
                message = message.replace("{" + layout.hebrew_name + "}", layout.preview_txt);
                message = message.replace("[" + layout.hebrew_name + "]", layout.preview_txt);
            }
        });

        this.dialogMessage = message;
        this.isPreviewDialogVisible = true;
    }

    closePreviewModal(): void {
        this.isPreviewDialogVisible = false;
    }

    closeDialog(): void {
        this.isDialogVisible = false;
    }

    toggleInput(inputId: number): void {
        if (inputId == 1) {
            this.isEditingFirstInput = true;
            this.previousInputValue = this.receivedparameters.phone1SendReportCash;
            setTimeout(() => {
                this.firstInput.nativeElement.focus();
            }, 0);
        }
        else if (inputId == 2) {
            this.isEditingSecondInput = true;
            this.previousInputValue = this.receivedparameters.phone2SendReportCash;
            setTimeout(() => {
                this.secondInput.nativeElement.focus();
            }, 0);
        }
    }

    cancelInput(inputId: number): void {
        if (inputId == 1) {
            this.receivedparameters.phone1SendReportCash = this.previousInputValue;
            this.isFirstInputValid = true;
            this.isEditingFirstInput = false;
        }
        else if (inputId == 2) {
            this.receivedparameters.phone2SendReportCash = this.previousInputValue;
            this.isSecondInputValid = true;
            this.isEditingSecondInput = false;
        }
    }

    saveInput(inputId: number): void {
        if (inputId == 1) {
            if (this.firstInput.nativeElement.validity.valid) {
                this.isFirstInputValid = true;
                this.isEditingFirstInput = false;
            }
            else {
                this.isFirstInputValid = false;
                setTimeout(() => {
                    this.firstInput.nativeElement.focus();
                }, 0);
            }
        }
        else if (inputId == 2) {
            if (this.secondInput.nativeElement.validity.valid) {
                this.isSecondInputValid = true;
                this.isEditingSecondInput = false;
            }
            else {
                this.isSecondInputValid = false;
                setTimeout(() => {
                    this.secondInput.nativeElement.focus();
                }, 0);
            }
        }
    }

    settingsCheckboxClick(): void {
        (document.activeElement as HTMLElement).blur();

        if (!this.receivedparameters.isAddLink) {
            this.dialogTitle = "אנא בדקו את ההודעה אחרי הסרת הלינק";
            this.dialogMessage = "שימו לב שלא נשאר מלל מיותר אחרי שהסרנו את הלינק מהתבנית (רק הלינק עצמו מתבטל אוטומטית). אם נשאר - לחצו על \"עריכה\" כדי לתקן ידנית";
            this.isDialogVisible = true;
        }
        else {
            this.dynamicDialogService.openDialog(ChildadminpanelComponent, {
                styleClass: "modal modal_purpose_admin-panel",
                closeOnEscape: false,
                showHeader: false
            }).onClose.subscribe(() => {
                this.dialogTitle = "שימו לב שהלינק לאישור הגעה הצטרף לסוף ההודעה";
                this.dialogMessage = "במידה ותרצו להעביר את הלינק לאמצע ההודעה ולהוסיף הנחייה (מומלץ), לחצו על הכפתור \"עריכה\" כדי לבצע את השינוי בעצמכם";
                this.isDialogVisible = true;
            });
        }

        this.casebody();
    }

    showAdminPanel(): void {
        (document.activeElement as HTMLElement).blur();

        this.dynamicDialogService.openDialog(ChildadminpanelComponent, {
            styleClass: "modal modal_purpose_admin-panel",
            closeOnEscape: false,
            showHeader: false
        });
    }

    preventDefault(event: Event): void {
        event.preventDefault();
    }

    casebody(): void {
        if (this.receivedparameters.daysbefore > 1 && (this.receivedparameters.isAddLink == false || this.receivedparameters.isAddLink === null)) {
            this.receivedparameters.bodyvizit = this.bodiescase.bodyvizit_2;
        }
        else if (this.receivedparameters.daysbefore == 1 && (this.receivedparameters.isAddLink == false || this.receivedparameters.isAddLink === null)) {
            this.receivedparameters.bodyvizit = this.bodiescase.bodyvizit_1;
        }

        if (this.receivedparameters.daysbefore > 1 && this.receivedparameters.isAddLink == true) {
            this.receivedparameters.bodyvizit = this.bodiescase.bodyvizit_2_i;
        }
        else if (this.receivedparameters.daysbefore == 1 && this.receivedparameters.isAddLink == true) {
            this.receivedparameters.bodyvizit = this.bodiescase.bodyvizit_1_i;
        }

        if (!this.receivedparameters.isAddLink && this.layouts) {
            this.receivedparameters.bodyvizit = this.receivedparameters.bodyvizit.replace(`[${this.layouts.find(x => x.name == "Link").hebrew_name}]`, "");
        }
    }

    getDataTemplates(): void {
        this.httpService1.getDataTemplates(this.user).subscribe((res: ParameterSMS) => {
            this.receivedparameters = res;

            this.receivedparameters.hourSend = new Date(this.receivedparameters.hourSend);
            this.receivedparameters.birthdayHourSend = new Date(this.receivedparameters.birthdayHourSend);

            if (!activeTemplates[0]) {
                this.receivedparameters.vizitReminder = false;
            }
            if (!activeTemplates[1]) {
                this.receivedparameters.birthdayReminder = false;
            }
            if (!activeTemplates[2]) {
                this.receivedparameters.creatingAppointmentReminder = false;
            }
            if (!activeTemplates[3]) {
                this.receivedparameters.cancelingAppointmentReminder = false;
            }
            if (!activeTemplates[4]) {
                this.receivedparameters.changingDateAppointmentReminder = false;
            }
            if (!activeTemplates[5]) {
                this.receivedparameters.changingTimeAppointmentReminder = false;
            }
            if (!activeTemplates[6]) {
                this.receivedparameters.thankByRecommendationReminder = false;
            }
            if (!activeTemplates[7]) {
                this.receivedparameters.thankByMeetingReminder = false;
            }
            if (!activeTemplates[8]) {
                this.receivedparameters.automaticClosingCash = false;
            }
            if (!activeTemplates[9]) {
                this.receivedparameters.sendReportCash = false;
            }

            this.isLoaderVisible = false;

            if (Object.keys(this.bodiescase).length) {
                this.casebody();
            }

            if (this.receivedparameters.bodyvizit !== sessionStorage.getItem("bodyvizit") && sessionStorage.getItem("bodyvizit") !== null) {
                this.receivedparameters.bodyvizit = sessionStorage.getItem("bodyvizit");
            }
            if (this.receivedparameters.bodyBirthday !== sessionStorage.getItem("bodyBirthday") && sessionStorage.getItem("bodyBirthday") !== null) {
                this.receivedparameters.bodyBirthday = sessionStorage.getItem("bodyBirthday");
            }
            if (this.receivedparameters.bodyCreatingAppointmentReminder !== sessionStorage.getItem("bodyCreatingAppointmentReminder") && sessionStorage.getItem("bodyCreatingAppointmentReminder") !== null) {
                this.receivedparameters.bodyCreatingAppointmentReminder = sessionStorage.getItem("bodyCreatingAppointmentReminder");
            }
            if (this.receivedparameters.bodyCancelingAppointmentReminder !== sessionStorage.getItem("bodyCancelingAppointmentReminder") && sessionStorage.getItem("bodyCancelingAppointmentReminder") !== null) {
                this.receivedparameters.bodyCancelingAppointmentReminder = sessionStorage.getItem("bodyCancelingAppointmentReminder");
            }
            if (this.receivedparameters.bodyChangingDateAppointmentReminder !== sessionStorage.getItem("bodyChangingDateAppointmentReminder") && sessionStorage.getItem("bodyChangingDateAppointmentReminder") !== null) {
                this.receivedparameters.bodyChangingDateAppointmentReminder = sessionStorage.getItem("bodyChangingDateAppointmentReminder");
            }
            if (this.receivedparameters.bodyChangingTimeAppointmentReminder !== sessionStorage.getItem("bodyChangingTimeAppointmentReminder") && sessionStorage.getItem("bodyChangingTimeAppointmentReminder") !== null) {
                this.receivedparameters.bodyChangingTimeAppointmentReminder = sessionStorage.getItem("bodyChangingTimeAppointmentReminder");
            }
            if (this.receivedparameters.bodyThankByRecommendationReminder !== sessionStorage.getItem("bodyThankByRecommendationReminder") && sessionStorage.getItem("bodyThankByRecommendationReminder") !== null) {
                this.receivedparameters.bodyThankByRecommendationReminder = sessionStorage.getItem("bodyThankByRecommendationReminder");
            }
            if (this.receivedparameters.bodyThankByMeetingReminder !== sessionStorage.getItem("bodyThankByMeetingReminder") && sessionStorage.getItem("bodyThankByMeetingReminder") !== null) {
                this.receivedparameters.bodyThankByMeetingReminder = sessionStorage.getItem("bodyThankByMeetingReminder");
            }

            if (this.receivedparameters.birthdayMethod === 2) {
                this.timeData = this.timeData.filter(item => item.id != 3);
            }

        }, error => {
            console.log(error);
            this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
        });
    }

    goAutomationMain(): void {
        this.user.useremail = sessionStorage.getItem("email");
        console.log("Email from sessionStorage: " + this.user.useremail);
        this.IsTokenValid();

        this.receivedparameters.hourSend = (this.receivedparameters.hourSend as Date).toLocaleTimeString("he-IL");
        this.receivedparameters.birthdayHourSend = (this.receivedparameters.birthdayHourSend as Date).toLocaleTimeString("he-IL");

        if (this.isEditingFirstInput) {
            this.cancelInput(1);
        }
        if (this.isEditingSecondInput) {
            this.cancelInput(2);
        }

        sessionStorage.setItem("bodyvizit", this.receivedparameters.bodyvizit);
        sessionStorage.setItem("bodyBirthday", this.receivedparameters.bodyBirthday);
        sessionStorage.setItem("bodyCreatingAppointmentReminder", this.receivedparameters.bodyCreatingAppointmentReminder);
        sessionStorage.setItem("bodyCancelingAppointmentReminder", this.receivedparameters.bodyCancelingAppointmentReminder);
        sessionStorage.setItem("bodyChangingDateAppointmentReminder", this.receivedparameters.bodyChangingDateAppointmentReminder);
        sessionStorage.setItem("bodyChangingTimeAppointmentReminder", this.receivedparameters.bodyChangingTimeAppointmentReminder);
        sessionStorage.setItem("bodyThankByRecommendationReminder", this.receivedparameters.bodyThankByRecommendationReminder);
        sessionStorage.setItem("bodyThankByMeetingReminder", this.receivedparameters.bodyThankByMeetingReminder);

        this.httpService1.setDataTemplates(this.user, this.receivedparameters)
            .subscribe((res: SetTemplateValid) => {
                this.receivedsettemplatevalid = res;
                this.receivedsettemplatevalid.answer = res.answer;
                if (!this.receivedsettemplatevalid.answer) {
                    this.dialogTitle = "הודעה למשתמש";
                    this.dialogMessage = "תקלה בשמירת נתונים,נא לנסות שנית"
                    this.isDialogVisible = true;
                    this.logger.info("Problem with saving data of templates for user with email: " + sessionStorage.getItem("email"));
                }
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });

        this.saveData = true;

        this.router.navigate(["mainsms"]);
    }
}
